import axios, { AxiosResponse } from "axios";
import apiService from "./apiService";

export default {
  async activate(code: string): Promise<AxiosResponse> {
    return await axios.post(
      apiService.stage.receiverActivationUrl() + code,
      {}
    );
  },
};
